import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function VerificationModal({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  const [pointsType, setPointsType] = useState<"add" | "remove">("add");

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Resend Verification</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="mb_20 hd_6">
            <h3>
              Are you sure you want to resend verification on the email or phone
              number?
            </h3>
          </div>

          <form className="form">
            <div className="control_group">
              <label htmlFor="sendTo">Send to</label>
              <RadioGroup
                id="sendTo"
                className="flex mt_10"
                value={pointsType}
                onChange={(e) =>
                  setPointsType(e.target.value as "add" | "remove")
                }
              >
                <FormControlLabel value="add" control={<Radio />} label="Email" />
                <FormControlLabel
                  value="remove"
                  control={<Radio />}
                  label="Phone Number"
                />
              </RadioGroup>
            </div>

            {pointsType === "add" && (
              <div className="control_group">
                <label htmlFor="emailInput">Email</label>
                <TextField
                  id="emailInput"
                  type="email"
                  variant="outlined"
                  placeholder="Enter Email"
                  fullWidth
                  hiddenLabel
                />
              </div>
            )}

            {pointsType === "remove" && (
              <div className="control_group">
                <label htmlFor="phoneInput">Phone Number</label>
                <TextField
                  id="phoneInput"
                  type="number"
                  variant="outlined"
                  placeholder="Enter Phone Number"
                  fullWidth
                  hiddenLabel
                />
              </div>
            )}

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
